import {PrimaryButton, SecondaryButton} from 'components';
import React, {useCallback, useContext, useMemo, useState} from 'react';
import {useFlowData} from '../../EditProcess/hooks/useFlowData';
import {transformRulesDataForApi} from '../hooks/ruleUtils';
import {useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import {useNavigate, useParams} from 'react-router-dom';
import SaveOrPublish from '../modals/SaveOrPublish';
import {ConfirmModal} from '../modals/ConfirmModals';
import Breadcrumbs from 'components/BreadCrumbs';
import {PAGES_URL} from 'helpers/constants';
import {EasyDetectContext} from '../../../../../helpers/context/EasyDetectContext';

function Navbar({rules, noNav, isListLoading}) {
  const {aggregateFunction, isAggregateFunction} =
    useContext(EasyDetectContext);
  const user = useSelector(state => state?.auth?.user);
  const [open, setOpen] = useState(false);
  const [clearOpen, setClearOpen] = useState(false);
  const {slug} = useParams();
  const navigate = useNavigate();
  const FLowData = useFlowData();

  const apiRuleData = useMemo(() => transformRulesDataForApi(rules), [rules]);
  const handleSaveRules = useCallback(async () => {
    if (Array.isArray(apiRuleData) && apiRuleData.length > 0) {
      for (const rule of apiRuleData) {
        if (!rule.id) {
          delete rule.id;
          delete rule.period;
          await FLowData.addNewTask({
            ...rule,
            event: {
              type: rule?.event?.type || 'medium_risk',
              ...rule.event,
              params: {
                ...rule.event.params,
                action: rule.event.action || 'REVIEW',
                risk_score:
                  rule.event.params?.risk_score || rule.event?.risk_score || 20,
                ...(isAggregateFunction
                  ? {
                      period: rule.event.params?.period || aggregateFunction,
                      period_minutes: rule.event.params?.period_minutes || 30,
                    }
                  : {}),
              },
            },
            created_by: user?.id,
          });
        } else if (rule.id) {
          delete rule.created_by;
          delete rule.period;
          await FLowData.updateExistingTask({
            id: rule.id,
            ...rule,
            updated_by: user?.id,
          });
        }
      }
      toast.success('Rule process saved successfully');
      setOpen(false);
    }
  }, [FLowData, aggregateFunction, apiRuleData, isAggregateFunction, user?.id]);

  const isModified = JSON.parse(localStorage.isModified || '{}');

  return (
    <>
      <div className="flex items-center bg-white min-h-[52px] py-2 flex-wrap gap-3 justify-between px-8 border border-transparent border-b-[#E4E4E6]">
        <Breadcrumbs
          items={[
            {label: 'Fraud Flows', path: PAGES_URL.FLOWS},
            {label: 'Rule Editor'},
          ]}
        />
      </div>{' '}
      <SaveOrPublish
        open={open}
        setOpen={setOpen}
        onPublish={async () => {
          await FLowData.publishRules();

          setOpen(false);
        }}
        pLoading={FLowData.publishingRules}
        pDisabled={Boolean(!isModified) || FLowData.publishingRules}
      />
      <ConfirmModal
        modalTitle="Confirm you want to clear saved rules"
        modalBody="This action will clear all the saved rules, and cannot be undone."
        buttonText="Clear"
        open={clearOpen}
        setOpen={setClearOpen}
        onClick={() => FLowData.clearRule(slug)}
        isLoading={FLowData.clearingRule}
      />
      {!noNav ? (
        <nav className="px-8 py-2 bg-[#F9F9F9] flex items-center justify-between">
          <PrimaryButton
            buttonText="Clear Process"
            className={`${
              isModified ? '!bg-[#B42318]' : ' border border-grey-100'
            } !px-3 !py-2 !text-[10px]`}
            onClick={() => setClearOpen(true)}
            loading={FLowData.clearingRule}
            disabled={Boolean(!isModified)}
          />

          <div className="flex items-center gap-3">
            <PrimaryButton
              buttonText="Save Process"
              className="!px-3 !py-2 !2 !text-[10px] border"
              onClick={handleSaveRules}
              loading={FLowData.addingTask || FLowData.updatingTask}
              disabled={Boolean(!rules.length) || isListLoading}
            />
            <SecondaryButton
              buttonText="Publish Flow"
              className="!px-3 !py-2 !text-[10px] !h-auto"
              // onClick={FLowData.publishRules}
              // loading={FLowData.publishingRules}
              disabled={Boolean(!isModified)}
              onClick={() => setOpen(!open)}
            />
          </div>
        </nav>
      ) : (
        <nav className="px-12 py-2 bg-[#F9F9F9] flex items-center justify-end w-full">
          <SecondaryButton
            buttonText="Close and Go Back"
            className="!px-3 !py-2 !text-[10px] !h-auto"
            onClick={() => navigate(-1)}
          />
        </nav>
      )}
    </>
  );
}

export default Navbar;
